export const NOTIFICATION_CENTER_PAGE_SIZE = 20;
export const NOTIFICATION_CENTER_DEADLINES_TAB_ID = "deadlines";
export const NOTIFICATION_CENTER_SETTINGS_TAB_ID = "settings";

export function isNotificationCenterPaginatedTable(tableId) {
  return Boolean(tableId) && tableId !== NOTIFICATION_CENTER_DEADLINES_TAB_ID;
}

export const NOTIFICATION_CENTER_TAB_KEYS = [
  "reporting",
  "messages",
  "cases",
  "charge_invoices",
  "product",
  "settings",
  "deadlines",
];
